import createReducer from '../utils/createReducer';
import { SAVE_URL_QUERY } from '../constants/actionTypes';

const initialState = {
  query: {}
};

const routeReducer = createReducer(initialState, {
  [SAVE_URL_QUERY]: (state, action) => ({
    query: action.query
  })
});

export default routeReducer;
